import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Card } from 'reactstrap';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { ArrowDropDownRounded, ArrowDropUpRounded } from '@material-ui/icons';
import LineChart from 'components/Charts/LineChart';
import { accentThree1000 as colorRedNegative, caribbeanGreen } from 'themes/colors';

const styles = theme => ({
  title: {
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.secondary.text,
  },
  value: {
    fontSize: '2rem',
    fontWeight: 600,
    color: theme.palette.secondary.text,
    marginBottom: '0.75rem',
  },
  percentageBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  percentage: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 600,
    marginRight: '0.5rem',
  },
  circle: {
    borderRadius: '50%',
    backgroundColor: theme.palette.primary['100'],
    width: '1rem',
    height: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
    marginTop: '-3px',
  },
  from: {
    color: theme.palette.gray.contrastText,
    fontSize: '12px',
  },
  responsiveWrapper: {
    width: '100%',
    height: '4rem',
    marginTop: '12px',
  },
  up: {
    color: caribbeanGreen,
  },
  down: {
    color: colorRedNegative,
  },
});

const LineChartCard = (props) => {
  const {
    tooltip, classes, className, graphData, dataKey, chartColor, title, growth, value, dataIntercomTarget,
  } = props;

  const growthClassName = growth <= -1 ? classes.down : classes.up;

  return (
    <Card className={className} data-intercom-target={dataIntercomTarget}>
      <div className={classes.title}>{title}</div>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <div className={classes.value}>{props.loading ? 'Loading...' : value}</div>
        </Tooltip>
      ) : (
        <div className={classes.value}>{props.loading ? 'Loading...' : value}</div>
      )}
      <div className={classes.percentageBlock}>
        {growth !== 'NA' && !Number.isNaN(growth) ? <>
          <div className={`${classes.percentage} ${growthClassName}`}>
            {props.loading ? 'Loading...' : `${+(growth).toFixed(2)}%`}
          </div>
          <div className={`${classes.circle} ${growthClassName}`}>
            {growth <= -1 ? <ArrowDropDownRounded /> : <ArrowDropUpRounded />}
          </div>
        </> : <div> NA </div>}
      </div>
      <div className={classes.from}>from the last period</div>
      {graphData && graphData.length > 0 &&
        <div className={classes.responsiveWrapper}>
          <LineChart loading={props.loading} graphData={graphData} dataKey={dataKey} chartColor={chartColor} />
        </div>
      }
    </Card>
  );
};

LineChartCard.propTypes = {
  classes: PropTypes.element.isRequired,
  className: PropTypes.string.isRequired,
  chartColor: PropTypes.string,
  title: PropTypes.string,
  graphData: PropTypes.shape({}),
  dataKey: PropTypes.string,
  growth: PropTypes.number,
  value: PropTypes.string,
  loading: PropTypes.bool,
  dataIntercomTarget: PropTypes.string,
  tooltip: PropTypes.string,
};

LineChartCard.defaultProps = {
  graphData: null,
  chartColor: 'blue',
  dataKey: null,
  title: 'Potential Reach',
  growth: 0,
  tooltip: null,
  value: '0%',
  loading: false,
  dataIntercomTarget: null,
};

export default withStyles(styles)(LineChartCard);
